export default "__VITE_ASSET__af7b96a4__"